<script setup>
import { displayPhone } from '@/plugins/misc'
import {useReservationsStore, useRestaurantsStore, useUsersStore} from "@/stores"
import { mediaUrl } from '@core/utils/mediaUrl'

import {useRoute} from "vue-router"
import {buildProfileUrl, getFullUrl} from "@/plugins/misc"
import socialRmLogo from "@/assets/social-rm.svg"
import {ref} from "vue"
const props = defineProps({
  user: {
    type: Object,
    required: true
  },
  noPhone: {
    type: Boolean,
    default: false
  },
  hideContactDetails: {
    type: Boolean,
    default: false
  },
  reservationType: {
    type: String,
    default: ''
  },
})
const route = useRoute()
const router = useRouter()

const isViewAndShareProfileDialogOpen = ref(false)

const usersStore = useUsersStore()
let myUser = null;
({ myUser } = storeToRefs(usersStore))

const reservationsStore = useReservationsStore()

const isMyUser = computed(() => {
  return myUser.value && myUser.value.email == props.user.email
})

//computed userToUse returns myUser if myUser email matches user.email, otherwise returns user
const userToUse = computed(() => {
  if (isMyUser.value) {
    return myUser.value
  } else {
    return props.user
  }
})
</script>

<template>
  <div>
    <template v-if="userToUse.userLevel == 'dummy'">
      <div class="text-xs">
        (restaurants review when evaluating requests)
      </div>
      <div class="flex align-center gap-2 pl-0 mb-0">
        <ViewAndShareProfileDialog
          v-model:is-dialog-visible="isViewAndShareProfileDialogOpen"
        />
        <div
          class="avatar rounded-circle mr-2"
          @click="(isMyUser ? usersStore.editMyUser() : null)"
        >
          <div class="avatar-fallback flex flex-row align-center justify-center">
            <span class="avatar-fallback-text text-xl"><VIcon>mdi-user</VIcon></span>
          </div>
        </div>
        <div
          class="user-info-content"
          style="line-height: 1.1em;"
        >
          <!--      <a :href="`/m/${userToUse?.profileId}`" target="_blank"  style="text-decoration: inherit; color: inherit;" class="mb-0 pb-0"> -->
          <div class="flex">
            <div class="flex flex-column">
              <div class="text-sm">
                Full Name<VIcon
                  size="16"
                  class="verified-icon ml-1"
                  style="margin: 0px; margin-top: -2px;"
                >
                  material-symbols:verified
                </VIcon> (Platinum)
              </div>
              <!--            <div class="text-xs mr-6">Platinum</div> -->
            </div>
          </div>
          <div
            style="line-height: 1.1em;"
            class="text-xs"
          >
            <div>Position - Company</div>
          </div>
        </div>
      </div>

      <!--    <div class="mt-1 mb-1"> -->
      <!--      <div class="mt-1 text-xs" style="line-height: 1.1em;"> -->
      <!--        ABC - Verified member of high profile group -->
      <!--      </div> -->
      <!--      <div class="mt-1 text-xs" style="line-height: 1.1em;"> -->
      <!--        XYZ PWM - Verified UHNW client of XYZ Private Wealth Management -->
      <!--      </div> -->
      <!--    </div> -->
      <div class="text-xs">
        Dine out personally & professionally 2-4 times a week. Love great Cabarnets, Clase Azul, Wagyu & Bluefin Tuna.
      </div>

      <VCol class="d-flex align-center pa-0 mt-1">
        <a
          href=""
          target="_blank"
        >
          <VIcon
            size="20"
            class="mr-3"
          >mdi-linkedin</VIcon>
        </a>
        <a
          href=""
          target="_blank"
        >
          <VIcon
            size="20"
            class="mr-3"
          >mdi-instagram</VIcon>
        </a>
      </VCol>

      <div class="mt-1">
        M. (123) 456-7890 | your@email.com
      </div>

      <div
        v-if="isMyUser && userToUse.phoneNumber"
        class="profile-header-edit-button-holder"
      >
        <VBtn
          size="small"
          width="fit-content"
          class="profile-header-edit-button"
          variant="text"
          prepend-icon="mdi-edit"
          density="compact"
          @click="usersStore.editMyUser()"
        >
          Edit Profile
        </VBtn>
      </div>
    </template>
    <template v-else>
      <div class="flex align-center gap-2 pl-0 mb-0">
        <ViewAndShareProfileDialog
          v-model:is-dialog-visible="isViewAndShareProfileDialogOpen"
        />
        <div
          class="avatar rounded-circle mr-2"
          @click="(isMyUser ? usersStore.editMyUser() : null)"
        >
          <VImg
            v-if="userToUse?.profileImageId"
            class="avatar-image"
            :src="mediaUrl(userToUse?.profileImageId, 'small')"
            cover
          />
          <div
            v-else
            class="avatar-fallback flex flex-row align-center justify-center"
          >
            <span class="avatar-fallback-text">{{ userToUse?.firstName?.[0]?.toUpperCase() }}{{ userToUse?.lastName?.[0]?.toUpperCase() }}</span>
          </div>
        </div>
        <div
          class="user-info-content"
          style="line-height: 1.1em;"
        >
          <!--      <a :href="`/m/${userToUse?.profileId}`" target="_blank"  style="text-decoration: inherit; color: inherit;" class="mb-0 pb-0"> -->
          <div class="flex">
            <div class="flex flex-column">
              <div class="text-sm">
                {{ userToUse.fullName }}<VIcon
                  v-if="userToUse.isPlatinum && userToUse?.verified"
                  size="16"
                  class="verified-icon ml-1"
                  style="margin: 0px; margin-top: -2px;"
                >
                  material-symbols:verified
                </VIcon> ({{ userToUse.membershipType }})
              </div>
              <!--            <div class="text-xs mr-6">{{ userToUse.membershipType }}</div> -->
            </div>
          </div>
          <!--      </a> -->
          <a
            v-if="userToUse.membershipType == 'Trial' && userToUse.referredBy"
            :href="`/m/${userToUse?.profileId}`"
            target="_blank"
            style=" color: inherit;"
            class="mt-0"
          >
            <b><span>Referred by {{ userToUse.referredBy }}</span>
            </b>
          </a>
          <div
            style="line-height: 1.1em;"
            class="text-xs"
          >
            <div v-if="userToUse?.title && userToUse?.company">
              {{ userToUse.title }} - {{ userToUse.company }}
            </div>
            <div v-else-if="userToUse?.company">
              {{ userToUse.company }}
            </div>
            <div
              v-if="userToUse?.title2 && userToUse?.company2"
              style="margin-top: 0.25em;"
            >
              {{ userToUse.title2 }} - {{ userToUse.company2 }}
            </div>
            <div
              v-else-if="userToUse?.company2"
              style="margin-top: 0.25em;"
            >
              {{ userToUse.company2 }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="isMyUser && !userToUse.profileImageId">
        <div
          class="text-primary cursor-pointer text-caption ml-2"
          @click="usersStore.editMyUser()"
        >
          + profile pic
        </div>
      </div>
      <div
        v-if="userToUse.isPlatinum && userToUse.verifiedTags?.length > 0"
        class="mt-1 mb-1"
      >
        <MemberVerifiedTags :member="userToUse" />
      </div>
      <div
        v-if="userToUse.bio"
        class="text-xs"
      >
        {{ userToUse.bio }}
      </div>
      <VCol class="d-flex align-center pa-0 mt-1">
        <!--                  <a v-if="userToUse?.profileId" :href="`/m/${userToUse?.profileId}`" target="_blank" style="height:20px;"> -->
        <!--                    <img :src="socialRmLogo" height="20" class="mr-3"/> -->
        <!--                  </a> -->
        <a
          v-if="userToUse?.profileLinkedInProfileId"
          :href="buildProfileUrl('linkedin', userToUse?.profileLinkedInProfileId)"
          target="_blank"
        >
          <VIcon
            size="20"
            class="mr-3"
          >mdi-linkedin</VIcon>
        </a>
        <a
          v-if="userToUse?.profileInstagramProfileId"
          :href="buildProfileUrl('instagram', userToUse?.profileInstagramProfileId)"
          target="_blank"
        >
          <VIcon
            size="20"
            class="mr-3"
          >mdi-instagram</VIcon>
        </a>
        <a
          v-if="userToUse?.profileXProfileId"
          :href="buildProfileUrl('twitter', userToUse?.profileXProfileId)"
          target="_blank"
        >
          <VIcon
            size="20"
            class="mr-3"
          >simple-icons:x</VIcon>
        </a>
        <a
          v-if="userToUse?.profileTikTokProfileId"
          :href="buildProfileUrl('tiktok', userToUse?.profileTikTokProfileId)"
          target="_blank"
        >
          <VIcon
            size="20"
            class="mr-3"
          >simple-icons:tiktok</VIcon>
        </a>
        <a
          v-if="userToUse?.profileWebsiteLink"
          :href="getFullUrl(userToUse?.profileWebsiteLink)"
          target="_blank"
        >
          <VIcon
            size="20"
            class="mr-3"
          >mdi-web</VIcon>
        </a>
      </VCol>
    
      <!--    -->
      <!--    <div v-if="userToUse?.profileId" class="text-xs mt-1"> -->
      <!--      RM: <a @click="isViewAndShareProfileDialogOpen = true;" target="_blank" class="cursor-pointer"> -->
      <!--      reserverm.com/m/{{userToUse?.profileId}} -->
      <!--    </a> -->
      <!--    </div> -->
      <!--    <div v-if="userToUse?.profileWebsiteLink" class="text-xs"> -->
      <!--      Bio page: <a :href="getFullUrl(userToUse?.profileWebsiteLink)" target="_blank" > -->
      <!--      {{userToUse?.profileWebsiteLink}} -->
      <!--    </a> -->
      <!--    </div> -->
      <!--    <div v-if="userToUse?.profileLinkedInProfileId" class="text-xs"> -->
      <!--      LinkedIn: <a :href="buildProfileUrl('linkedin', userToUse?.profileLinkedInProfileId)" target="_blank" > -->
      <!--      linkedin.com/in/{{userToUse?.profileLinkedInProfileId}} -->
      <!--    </a> -->
      <!--    </div> -->
      <!--    <div v-if="userToUse?.profileInstagramProfileId" class="text-xs"> -->
      <!--      Instagram: <a :href="buildProfileUrl('instagram', userToUse?.profileInstagramProfileId)" target="_blank" > -->
      <!--      instagram.com/{{userToUse?.profileInstagramProfileId}} -->
      <!--    </a> -->
      <!--    </div> -->
      <!--    <div v-if="userToUse?.profileXProfileId" class="text-xs"> -->
      <!--      X: <a :href="buildProfileUrl('twitter', userToUse?.profileXProfileId)" target="_blank" > -->
      <!--      twitter.com/{{userToUse?.profileXProfileId}} -->
      <!--    </a> -->
      <!--    </div> -->
      <!--    <div v-if="userToUse?.profileTikTokProfileId" class="text-xs"> -->
      <!--      TikTok: <a :href="buildProfileUrl('tiktok', userToUse?.profileTikTokProfileId)" target="_blank" > -->
      <!--      tiktok.com/@{{userToUse?.profileTikTokProfileId}} -->
      <!--    </a> -->
      <!--    </div> -->

      <div
        v-if="!hideContactDetails"
        class="text-xs mt-1"
      >
        <template v-if="!noPhone">
          M. {{ (userToUse.phoneNumber ? displayPhone(userToUse.phoneNumber) + ' | ' : `(Required)`) }}
          <VBtn
            v-if="isMyUser && !userToUse.phoneNumber"
            width="fit-content"
            class="profile-header-edit-button"
            variant="text"
            prepend-icon="mdi-edit"
            density="compact"
            @click="usersStore.editMyUser()"
          >
            Add
          </VBtn>
        </template>
        {{ (userToUse.userLevel == 'dummy' ? '' : userToUse.email ) }}<br>
      </div>
      <!--    <div v-if="userToUse.userLevel !== 'dummy'" class="text-xs mt-1"> -->
      <!--      M. {{ userToUse.phoneNumber}} | {{ userToUse.email }} -->
      <!--    </div> -->

      <!--    <div v-if="isMyUser && (userToUse.phoneNumber || hideContactDetails)" class="profile-header-edit-button-holder"> -->
      <!--      <v-btn -->
      <!--        size="small" -->
      <!--        width="fit-content" -->
      <!--        class="profile-header-edit-button" -->
      <!--        variant="text" -->
      <!--        prepend-icon="mdi-edit" -->
      <!--        density="compact" -->
      <!--        @click="usersStore.editMyUser()" -->
      <!--      >Edit Profile -->
      <!--      </v-btn> -->
      <!--    </div> -->
    </template>
  </div>
</template>

<style scoped>
.avatar {
  width: 4rem;
  height: 4rem;
  flex-shrink: 0;
  background: var(--ds-brand-primary-light);
  outline: thin solid rgba(69, 182, 169, 0.25);
  outline-offset: 0.25rem;
  margin: 0.5rem;
}

@media screen and (min-width: 670px) {
  .avatar {
    width: 5rem;
    height: 5rem;
    outline-offset: 0.25rem;
    margin: 0.5rem;

  }
}

.avatar-fallback {
  width: 100%;
  height: 100%;
  font-size: 1.6rem;
}

.avatar-image {
  border-radius: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (min-width: 670px) {
  .avatar-fallback {
    font-size: 2rem;
  }
}

.avatar-fallback-text {
  width: fit-content;
}


.verified-icon {
  color: rgb(0, 149, 246);
  width: 1.25rem;
  height: 1.25rem;
  margin-bottom: 5px;
}

.profile-header-edit-button-holder {
  margin-top: 0.5em;
  margin-left: -14px;
}

/* @media query for .profile-header-edit-button-holder - removed empty ruleset */
</style>
